<template>
  <validationProvider
    :rules="{ required: true, regex: /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/ }"
    v-slot="{ errors, valid }"
    name="スカイプID"
    immediate
  >
    <p>
      <FormTitleText :titleText="$t('profile.skypeId')" />
      <FormAttentionText :attentionText="$t('profile.onlyHalfWidthAndNum')" />
    </p>
    <v-text-field
      label="skypeid"
      v-model="inputedSkypeId"
      outlined
      background-color="white"
      hide-details
      :success="valid"
    ></v-text-field>
    <FormErrorText :errorText="errors[0]" />
  </validationProvider>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText';
import FormErrorText from '../Atoms/FormErrorText';
import FormAttentionText from '../Atoms/FormAttentionText';

export default {
  name: 'SkypeIdForm',
  data: () => ({
  }),
  props: ['value'],
  mounted() {
  },
  computed: {
    inputedSkypeId: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
  },
  components: {
    FormTitleText,
    FormErrorText,
    FormAttentionText
  }
};
</script>

<style lang="scss" scoped>
</style>
